import React from 'react';
import Carousel from 'react-material-ui-carousel'
import { Paper, Button, Card, CardMedia, Grid } from '@mui/material'
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { useStore } from '../../../../state/MobxContext';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import Box from '@mui/material/Box';
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import JsBarcode from "jsbarcode";
import { useEffect, useState } from "react";

function CouponitemCard(props) {

  // console.log("props", props);
  const { SaleStore } = useStore();


  const [imageUrl, setImageUrl] = useState('');




  const useStyles = makeStyles((theme) => ({
    //BrandImage
    BrandImage: {
      // whiteSpace: "nowrap",
      // objectFit: "cover",
      width: '100%',
      height: "8rem"
    },
    //BrandiamgeSlide
    BrandiamgeSlide: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }));

  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");



  let epin = String(props.item?.member_epin);
  // let epin = String(12345678123);


  useEffect(() => {// 바코드 이미지 생성
    if (epin !== undefined && epin !== null && epin !== "") {
      const canvas = document.createElement('canvas')
      JsBarcode(canvas, epin, { height: 50, displayValue: true, format: "CODE128", fontSize: 15 })
      setImageUrl(canvas.toDataURL('image/png'))
    }
  }, [epin]);




  const BrandTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.8rem',
        alignItems: 'center',
        justifyContent: "center"
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
        alignItems: 'center',
        justifyContent: "center"
      }
  })(Typography);



  return (
    <Box display="inline-block">
      <Card key={props.item.Index}
        sx={isMobile ? { bgcolor: "black", maxWidth: "100%", m: 1, boxShadow: 10, marginBottom: "1rem" } 
        :
        { bgcolor: "black", maxWidth: "30rem", m: 0, boxShadow: 10 }} >
        <Grid container direction='row' justifyContent='center' alignItems='center'
        // onClick={() => { SaleStore?.setCouponitemPage(props.item) }}
        >
        </Grid>
        <CardMedia
          component="img"
          sx={isMobile ? { height: "100%" } : { height: 350 }}
          image={props.item.image}
          alt={props.item.goods_name}
        // onClick={() => { SaleStore?.setCouponitemPage(props.item) }}
        />
        <img 
        style={{width: "100%"}} 
        src={imageUrl} alt="props.item.goods_name" /> 
        <Grid container direction='row' justifyContent='center' alignItems='center'
        // onClick={() => { SaleStore?.setCouponitemPage(props.item) }}
        >
          <BrandTypographyMobile>
            {props.item.Brand}
            <br />
            {props.item.member_exdate}
          </BrandTypographyMobile>
        </Grid>
      </Card>
    </Box>
  )
}

export default observer(CouponitemCard);
